<template>
  <div class="textarea-wrapper">
    <label :for="name" class="custom-textarea-label">
      {{ label }}
      <textarea
        ref="textarea"
        :placeholder="placeholder"
        :id="name"
        :value="value"
        @blur="$emit('blur', $event.target.value)"
        @focus="$emit('focus')"
        @input="$emit('input', $event.target.value)"
        class="custom-textarea control custom-scrollbar"
        :class="{ 'is-error': isError || isOver, 'autoresizable': autoresize }"
        :cols="cols"
        :rows="rows"
        :maxlength="maxlength"
      ></textarea>
    </label>
    <span v-if="isOver || (isOver && isError)" class="error-message">{{ $t('review.is.over') }}</span>
    <span v-else-if="isError" class="error-message">{{ $t('subscribe_empty') }}</span>
  </div>
</template>

<script>
export default {
  name: 'CustomTextarea',
  props: {
    cols: {
      type: Number,
      default: 30
    },
    rows: {
      type: Number,
      default: 10
    },
    maxlength: {
      type: Number,
      default: 400
    },
    name: {
      type: String,
      default: ''
    },
    label: {
      type: String,
      default: ''
    },
    placeholder: {
      type: String,
      default: ''
    },
    isError: {
      type: Boolean,
      default: false
    },
    isOver: {
      type: Boolean,
      default: false
    },
    value: String,
    autoresize: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    resize (e) {
      setTimeout(() => {
        this.$refs.textarea.style.minHeight = 'auto'
        this.$refs.textarea.style.minHeight = this.$refs.textarea.scrollHeight + 'px'
      }, 0)
    }
  },
  mounted () {
    if (this.autoresize) {
      this.$watch('value', () => {
        this.resize()
      })
    }
  }
}
</script>

<style scoped lang="sass">

.custom-textarea
  resize: none
  width: 100%
  border-radius: 3px
  margin-top: 10px
  padding: 7px 11px
  color: $text-color
  border-color: #e7e7e7
  &:not(.autoresizable)
    max-height: 100px
    height: 100px
  &.autoresizable
    overflow-y: hidden
.custom-textarea-label
  font-size: 14px

.is-error
  border-color: $nd-error-text-color

.error-message
  font-size: 12px
  padding: 0 0 0 10px
  color: $nd-error-text-color
  display: block
  max-width: 70%

.comment-form__questions-item
  .custom-textarea-label
    font-size: 18px
    font-weight: 500
.vd-section__textarea-wrap
  .custom-textarea
    background-color: rgba(0, 0, 0, 0.06)
    border-color: transparent
    height: 180px
    max-height: 180px
    padding: 25px
    margin-top: 30px

  .custom-textarea-label
    font-size: 18px
    font-weight: 500

    +mmin($tablet--hor)
      font-size: 24px

  .is-error
    border-color: $nd-error-text-color
</style>
